module.exports = __webpack_public_path__ + "89d049c1.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_attached.png
// module id = 1161
// module chunks = 0 1 2